import * as React from 'react';
import { connect } from 'react-redux';
import { IFilters } from 'src/interfaces';
import { format } from 'date-fns';

import { MonthlyFormModel } from '../../../model/MonthlyFormModel';
import { getMonthlyFormDetails } from '../../../services/monthlyFormService';
import { DetailsPageWrapper } from '../../reusableComponents/DetailsPageWrapper';
import { inspectionType } from '../../../constants/generals';
import { getPageTitle } from '../../../utils/generalUtils';

export interface IDetailsPageProps {
    id: string;
    instance: MonthlyFormModel;
    filters: IFilters;
    formInstance: MonthlyFormModel;
}

export class DetailsPageImpl extends React.Component<IDetailsPageProps, {}> {

    static defaultProps: IDetailsPageProps;

    promise = async () => {

        await getMonthlyFormDetails(this.props.id, 'report');
    }

    render() {
        let pageTitle: string = '';
        let formType: string = this.props.instance && this.props.instance.props.type || ''; 
        let reportType: string = this.props.instance && this.props.instance.props.ReportType || '';  
        if(formType) {
            if(formType == 'MonthlySPCC' && reportType == 'new') {
                //pageTitle = `${inspectionType(this.props.instance.props.type)} Inspection Report for ${format(this.props.instance.props.Date, 'MMMM YYYY')}`;
                pageTitle = `${getPageTitle(formType, 'monthly', this.props.instance.props.Date, 'reportNew')} `;
            } else {
                //pTitle = `${inspectionType(this.props.instance.props.type)} Form Details ${format(this.props.instance.props.Date, 'MMMM YYYY')}`;
                pageTitle = `${getPageTitle(formType, 'monthly', this.props.instance.props.Date, 'report')} `;
            }
        } else {
            pageTitle = 'Monthly Form';
        }
        return (
            <DetailsPageWrapper
                id=""
                type={this.props.instance && this.props.instance.props.type}
                //pageTitle={this.props.instance ?  `${inspectionType(this.props.instance.props.type)} Form Details` : 'Monthly Form'}
                pageTitle={pageTitle}
                backTo="monthly"
                formType="monthly"
                instance={this.props.instance}
                promise={this.promise}
            />
        );
    }
}

export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    const instance = MonthlyFormModel.get(id);
    return {
        instance, id
    };
}

export const DetailsPage = connect<{}, {}, IDetailsPageProps>(mapStateToProps)(DetailsPageImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Monthly/DetailsPage.tsx